// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.displayCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}

.displayCenterColumn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.displayStart {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.displayStartColumn {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.displayEnd {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.displaySpacebetween {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.displaySpacearound {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.announcement-stripe {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 50px; /* Adjust the height as needed */
  background-color: transparent; /* Adjust the background color */
}

.announcement-stripe-1 {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 40px; /* Adjust the height as needed */
  background-color: transparent; /* Adjust the background color */
  display: flex;
  align-items: center;
}

.announcement-text {
  position: absolute;
  white-space: nowrap;
  animation: marquee 25s linear infinite; /* Adjust animation duration */
  overflow: hidden;
}

.announcement-text-1 {
  white-space: nowrap;
  animation: marquee 150s linear infinite; /* Adjust animation duration */
}

.uploadText {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@keyframes marquee {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(-100%);
  }
}
.react-tel-input .country-list .country-name {
  color: black;
}

.react-tel-input .form-control {
  width: 100%;
}

.react-tel-input {
  width: -moz-fit-content;
  width: fit-content;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

/* Track */
::-webkit-scrollbar {
  width: 5px; /* Width of the scrollbar */
  background-color: #555;
  height: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: linear-gradient(151deg, rgba(204, 120, 41, 0.92) 18.12%, rgb(255, 202, 101) 71.56%); /* Color of the scrollbar handle */
  border-radius: 5px; /* Rounded corners */
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; /* Color on hover */
}

li {
  padding-bottom: 10px;
  font-size: 14px;
}

.waiting {
  color: #83818e !important;
}

.green {
  color: #30b601 !important;
  font-weight: 600 !important;
}

.icocmargin svg {
  margin-right: 7px;
}

.qr-code-container {
  border-radius: 10px; /* Adjust the value to change the roundness */
  overflow: hidden;
}

.selectBox {
  display: flex;
  align-items: center;
}

/* SupportButton.css */
.support-button {
  position: absolute;
  bottom: 20px;
  left: 20px;
  padding: 10px;
  color: #fff;
  border: none;
  border-radius: 5px;
  text-decoration: none;
  cursor: pointer;
}

.card {
  background-color: #292929;
  color: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  background-color: #363636;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.flexBox {
  background: #2c2c2c;
  padding: 20px;
  position: relative;
  z-index: 1;
  overflow: hidden;
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
}

.flexBox:hover {
  transform: translateY(-5px);
}

.flexBox::before {
  content: " ";
  position: absolute;
  /* top: 0px; */
  width: 240px;
  height: 200%;
  animation: animate 10s linear infinite;
  background: #ffca65;
  border-radius: 20px;
}

.flexBoxLight {
  background: #fff;
  padding: 20px;
  position: relative;
  z-index: 1;
  overflow: hidden;
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
}

.flexBoxLight:hover {
  transform: translateY(-5px);
}

.flexBoxLight::before {
  content: " ";
  position: absolute;
  /* top: 0px; */
  width: 240px;
  height: 200%;
  animation: animate 10s linear infinite;
  background: #ffca65;
  border-radius: 20px;
}

@keyframes animate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.flexBox::after {
  content: " ";
  inset: 2px;
  background: #2c2c2c;
  position: absolute;
  border-radius: 20px;
}

.flexBoxLight::after {
  content: " ";
  inset: 2px;
  background: #f7f7f7;
  position: absolute;
  border-radius: 20px;
}

.mainContainer {
  padding: 0px 250px;
}

@media (max-width: 1540px) {
  .mainContainer {
    padding: 0px 180px;
  }
}
@media (max-width: 1280px) {
  .mainContainer {
    padding: 0px 80px;
  }
}
@media (max-width: 1000px) {
  .mainContainer {
    padding: 0px 60px;
  }
}
@media (max-width: 599.9px) {
  .mainContainer {
    padding: 0px 40px;
  }
}
@media (max-width: 393px) {
  .mainContainer {
    padding: 0px 20px;
  }
  .uploadText {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/_base.scss","webpack://./src/scss/main.css","webpack://./src/scss/_responsive.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;ACCF;;ADCA;EACE,aAAA;EAEA,2BAAA;EACA,sBAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;ACCF;;ADEA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA,EAAA,gCAAA;EACA,6BAAA,EAAA,gCAAA;ACCF;;ADCA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA,EAAA,gCAAA;EACA,6BAAA,EAAA,gCAAA;EACA,aAAA;EACA,mBAAA;ACEF;;ADuBA;EACE,kBAAA;EACA,mBAAA;EACA,sCAAA,EAAA,8BAAA;EACA,gBAAA;ACpBF;;ADuBA;EAEE,mBAAA;EACA,uCAAA,EAAA,8BAAA;ACrBF;;ADyBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;ACtBF;;ADyBA;EACE;IACE,2BAAA;ECtBF;EDwBA;IACE,4BAAA;ECtBF;AACF;ADyBA;EACE,YAAA;ACvBF;;ADyBA;EACE,WAAA;ACtBF;;ADwBA;EACE,uBAAA;EAAA,kBAAA;ACrBF;;ADuBA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;ACpBF;;ADuBA,YAAA;AACA;EACE,0BAAA;ACpBF;;ADuBA,UAAA;AACA;EACE,UAAA,EAAA,2BAAA;EACA,sBAAA;EACA,WAAA;ACpBF;;ADuBA,WAAA;AACA;EACE,+FAAA,EAIG,kCAAA;EACH,kBAAA,EAAA,oBAAA;ACxBF;;AD2BA,oBAAA;AACA;EACE,gBAAA,EAAA,mBAAA;ACxBF;;AD2BA;EACE,oBAAA;EACA,eAAA;ACxBF;;AD2BA;EACE,yBAAA;ACxBF;;AD2BA;EACE,yBAAA;EACA,2BAAA;ACxBF;;AD4BE;EACE,iBAAA;ACzBJ;;AD6BA;EACE,mBAAA,EAAA,6CAAA;EACA,gBAAA;AC1BF;;AD6BA;EACE,aAAA;EACA,mBAAA;AC1BF;;AD6BA,sBAAA;AACA;EACE,kBAAA;EAEA,YAAA;EACA,UAAA;EACA,aAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;AC5BF;;AD+BA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,wCAAA;EACA,2DAAA;AC5BF;;AD+BA;EACE,2BAAA;EACA,yBAAA;EACA,2DAAA;AC5BF;;AD+BA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AC5BF;;AD+BA;EACE,2BAAA;AC5BF;;AD+BA;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,sCAAA;EACA,mBAAA;EACA,mBAAA;AC5BF;;AD8BA;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AC3BF;;AD8BA;EACE,2BAAA;AC3BF;;AD8BA;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,sCAAA;EACA,mBAAA;EACA,mBAAA;AC3BF;;AD6BA;EACE;IACE,uBAAA;EC1BF;ED6BA;IACE,yBAAA;EC3BF;AACF;AD8BA;EACE,YAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AC5BF;;AD8BA;EACE,YAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AC3BF;;ACvQA;EACE,kBAAA;AD0QF;;ACvQA;EACE;IACE,kBAAA;ED0QF;AACF;ACvQA;EACE;IACE,iBAAA;EDyQF;AACF;ACtQA;EACE;IACE,iBAAA;EDwQF;AACF;ACrQA;EACE;IACE,iBAAA;EDuQF;AACF;ACpQA;EACE;IACE,iBAAA;EDsQF;ECpQA;IACE,cAAA;EDsQF;AACF","sourcesContent":[".displayCenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.displayCenterColumn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.displayStart {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.displayStartColumn {\n  display: flex;\n  // align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n}\n\n.displayEnd {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.displaySpacebetween {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.displaySpacearound {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n}\n\n.announcement-stripe {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  height: 50px; /* Adjust the height as needed */\n  background-color: transparent; /* Adjust the background color */\n}\n.announcement-stripe-1 {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  height: 40px; /* Adjust the height as needed */\n  background-color: transparent; /* Adjust the background color */\n  display: flex;\n  align-items: center;\n}\n// .animation {\n//   -webkit-animation-timing-function: linear;\n//   animation-timing-function: linear;\n//   -webkit-animation-iteration-count: infinite;\n//   animation-iteration-count: infinite;\n//   -webkit-animation-name: animation-1hgl3te;\n//   animation-name: animation-1hgl3te;\n//   -webkit-animation-delay: 2s;\n//   animation-delay: 2s;\n//   animation-duration: 400s;\n// }\n// .animation-text {\n//   box-sizing: border-box;\n//   margin: 0;\n//   min-width: 0;\n//   display: -webkit-box;\n//   display: -webkit-flex;\n//   display: -ms-flexbox;\n//   display: flex;\n//   width: 100%;\n//   margin: 0;\n//   padding: 0;\n// }\n.announcement-text {\n  position: absolute;\n  white-space: nowrap;\n  animation: marquee 25s linear infinite; /* Adjust animation duration */\n  overflow: hidden;\n}\n\n.announcement-text-1 {\n  // position: absolute;\n  white-space: nowrap;\n  animation: marquee 150s linear infinite; /* Adjust animation duration */\n  // overflow: hidden;\n}\n\n.uploadText {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n@keyframes marquee {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(-100%);\n  }\n}\n\n.react-tel-input .country-list .country-name {\n  color: black;\n}\n.react-tel-input .form-control {\n  width: 100%;\n}\n.react-tel-input {\n  width: fit-content;\n}\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n/* Track */\n::-webkit-scrollbar {\n  width: 5px; /* Width of the scrollbar */\n  background-color: #555;\n  height: 5px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: linear-gradient(\n    151deg,\n    rgba(204, 120, 41, 0.92) 18.12%,\n    rgb(255, 202, 101) 71.56%\n  ); /* Color of the scrollbar handle */\n  border-radius: 5px; /* Rounded corners */\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555; /* Color on hover */\n}\n\nli {\n  padding-bottom: 10px;\n  font-size: 14px;\n}\n\n.waiting {\n  color: #83818e !important;\n}\n\n.green {\n  color: #30b601 !important;\n  font-weight: 600 !important;\n}\n\n.icocmargin {\n  svg {\n    margin-right: 7px;\n  }\n}\n\n.qr-code-container {\n  border-radius: 10px; /* Adjust the value to change the roundness */\n  overflow: hidden;\n}\n\n.selectBox {\n  display: flex;\n  align-items: center;\n}\n\n/* SupportButton.css */\n.support-button {\n  position: absolute;\n  // float: right;\n  bottom: 20px;\n  left: 20px;\n  padding: 10px;\n  // background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.card {\n  background-color: #292929;\n  color: #fff;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n.card:hover {\n  transform: translateY(-5px);\n  background-color: #363636;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n.flexBox {\n  background: #2c2c2c;\n  padding: 20px;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n  transition: 0.5s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 20px;\n}\n\n.flexBox:hover {\n  transform: translateY(-5px);\n}\n\n.flexBox::before {\n  content: \" \";\n  position: absolute;\n  /* top: 0px; */\n  width: 240px;\n  height: 200%;\n  animation: animate 10s linear infinite;\n  background: #ffca65;\n  border-radius: 20px;\n}\n.flexBoxLight {\n  background: #fff;\n  padding: 20px;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n  transition: 0.5s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 20px;\n}\n\n.flexBoxLight:hover {\n  transform: translateY(-5px);\n}\n\n.flexBoxLight::before {\n  content: \" \";\n  position: absolute;\n  /* top: 0px; */\n  width: 240px;\n  height: 200%;\n  animation: animate 10s linear infinite;\n  background: #ffca65;\n  border-radius: 20px;\n}\n@keyframes animate {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.flexBox::after {\n  content: \" \";\n  inset: 2px;\n  background: #2c2c2c;\n  position: absolute;\n  border-radius: 20px;\n}\n.flexBoxLight::after {\n  content: \" \";\n  inset: 2px;\n  background: #f7f7f7;\n  position: absolute;\n  border-radius: 20px;\n}\n",".displayCenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.displayCenterColumn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.displayStart {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.displayStartColumn {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n}\n\n.displayEnd {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.displaySpacebetween {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.displaySpacearound {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n}\n\n.announcement-stripe {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  height: 50px; /* Adjust the height as needed */\n  background-color: transparent; /* Adjust the background color */\n}\n\n.announcement-stripe-1 {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  height: 40px; /* Adjust the height as needed */\n  background-color: transparent; /* Adjust the background color */\n  display: flex;\n  align-items: center;\n}\n\n.announcement-text {\n  position: absolute;\n  white-space: nowrap;\n  animation: marquee 25s linear infinite; /* Adjust animation duration */\n  overflow: hidden;\n}\n\n.announcement-text-1 {\n  white-space: nowrap;\n  animation: marquee 150s linear infinite; /* Adjust animation duration */\n}\n\n.uploadText {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n@keyframes marquee {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(-100%);\n  }\n}\n.react-tel-input .country-list .country-name {\n  color: black;\n}\n\n.react-tel-input .form-control {\n  width: 100%;\n}\n\n.react-tel-input {\n  width: -moz-fit-content;\n  width: fit-content;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n/* Track */\n::-webkit-scrollbar {\n  width: 5px; /* Width of the scrollbar */\n  background-color: #555;\n  height: 5px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: linear-gradient(151deg, rgba(204, 120, 41, 0.92) 18.12%, rgb(255, 202, 101) 71.56%); /* Color of the scrollbar handle */\n  border-radius: 5px; /* Rounded corners */\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555; /* Color on hover */\n}\n\nli {\n  padding-bottom: 10px;\n  font-size: 14px;\n}\n\n.waiting {\n  color: #83818e !important;\n}\n\n.green {\n  color: #30b601 !important;\n  font-weight: 600 !important;\n}\n\n.icocmargin svg {\n  margin-right: 7px;\n}\n\n.qr-code-container {\n  border-radius: 10px; /* Adjust the value to change the roundness */\n  overflow: hidden;\n}\n\n.selectBox {\n  display: flex;\n  align-items: center;\n}\n\n/* SupportButton.css */\n.support-button {\n  position: absolute;\n  bottom: 20px;\n  left: 20px;\n  padding: 10px;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.card {\n  background-color: #292929;\n  color: #fff;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n.card:hover {\n  transform: translateY(-5px);\n  background-color: #363636;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n.flexBox {\n  background: #2c2c2c;\n  padding: 20px;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n  transition: 0.5s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 20px;\n}\n\n.flexBox:hover {\n  transform: translateY(-5px);\n}\n\n.flexBox::before {\n  content: \" \";\n  position: absolute;\n  /* top: 0px; */\n  width: 240px;\n  height: 200%;\n  animation: animate 10s linear infinite;\n  background: #ffca65;\n  border-radius: 20px;\n}\n\n.flexBoxLight {\n  background: #fff;\n  padding: 20px;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n  transition: 0.5s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 20px;\n}\n\n.flexBoxLight:hover {\n  transform: translateY(-5px);\n}\n\n.flexBoxLight::before {\n  content: \" \";\n  position: absolute;\n  /* top: 0px; */\n  width: 240px;\n  height: 200%;\n  animation: animate 10s linear infinite;\n  background: #ffca65;\n  border-radius: 20px;\n}\n\n@keyframes animate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.flexBox::after {\n  content: \" \";\n  inset: 2px;\n  background: #2c2c2c;\n  position: absolute;\n  border-radius: 20px;\n}\n\n.flexBoxLight::after {\n  content: \" \";\n  inset: 2px;\n  background: #f7f7f7;\n  position: absolute;\n  border-radius: 20px;\n}\n\n.mainContainer {\n  padding: 0px 250px;\n}\n\n@media (max-width: 1540px) {\n  .mainContainer {\n    padding: 0px 180px;\n  }\n}\n@media (max-width: 1280px) {\n  .mainContainer {\n    padding: 0px 80px;\n  }\n}\n@media (max-width: 1000px) {\n  .mainContainer {\n    padding: 0px 60px;\n  }\n}\n@media (max-width: 599.9px) {\n  .mainContainer {\n    padding: 0px 40px;\n  }\n}\n@media (max-width: 393px) {\n  .mainContainer {\n    padding: 0px 20px;\n  }\n  .uploadText {\n    display: block;\n  }\n}/*# sourceMappingURL=main.css.map */",".mainContainer {\n  padding: 0px 250px;\n}\n\n@media (max-width: 1540px) {\n  .mainContainer {\n    padding: 0px 180px;\n  }\n}\n\n@media (max-width: 1280px) {\n  .mainContainer {\n    padding: 0px 80px;\n  }\n}\n\n@media (max-width: 1000px) {\n  .mainContainer {\n    padding: 0px 60px;\n  }\n}\n\n@media (max-width: 599.9px) {\n  .mainContainer {\n    padding: 0px 40px;\n  }\n}\n\n@media (max-width: 393px) {\n  .mainContainer {\n    padding: 0px 20px;\n  }\n  .uploadText {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
